/* Tiger Wear — Recently viewed products (localStorage) */
(function () {
  var KEY = 'tw_recently_viewed';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init() {
    var root = document.querySelector('[data-tw-recent]');
    if (!root || root.dataset.twInit) return;
    root.dataset.twInit = '1';

    var list = read();
    var curHandle = null;
    var rawCurrent = root.getAttribute('data-current');
    if (rawCurrent) {
      try {
        var c = JSON.parse(rawCurrent);
        if (c && c.handle) {
          curHandle = c.handle;
          list = list.filter(function (p) { return p.handle !== c.handle; });
          list.unshift(c);
          list = list.slice(0, 8);
          write(list);
        }
      } catch (e) {}
    }

    var show = list.filter(function (p) { return p && p.handle && p.handle !== curHandle; }).slice(0, 6);
    if (!show.length) return;

    var row = root.querySelector('[data-tw-recent-row]');
    row.innerHTML = show.map(function (p) {
      var img = p.image
        ? '<img class="tw-recent__img" src="' + esc(p.image) + '" alt="" loading="lazy" width="400" height="400">'
        : '<span class="tw-recent__img"></span>';
      return '<a class="tw-recent__card" href="' + esc(p.url) + '">' + img +
        '<span class="tw-recent__name">' + esc(p.title) + '</span>' +
        '<span class="tw-recent__price">' + esc(p.price) + '</span></a>';
    }).join('');
    root.removeAttribute('hidden');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
